module.exports = __webpack_public_path__ + "img/adobe-xd.957b5680.png";